import { FragmentRESTSerializer as RESTSerializer } from 'ember-data-model-fragments/serializer';
import PostTypes from '@linc-technologies/linced-common/enums/post-type';

export default class Base extends RESTSerializer {
  normalizeResponse(store, primaryModelClass, payload, id, requestType) {
    if (payload.comments) {
      payload.comments.forEach(this.normalizePostRelationship);
    } else if (payload.comment) {
      this.normalizePostRelationship(payload.comment);
    }

    if (payload.reactions) {
      payload.reactions.forEach(this.normalizePostRelationship);
    } else if (payload.reaction) {
      this.normalizePostRelationship(payload.reaction);
    }

    return super.normalizeResponse(
      store,
      primaryModelClass,
      payload,
      id,
      requestType,
    );
  }

  serializeIntoHash(hash) {
    super.serializeIntoHash(...arguments);

    if (hash.comments) {
      hash.comments.forEach(this.serializePostRelationship);
    } else if (hash.comment) {
      this.serializePostRelationship(hash.comment);
    }

    if (hash.reactions) {
      hash.reactions.forEach(this.serializePostRelationship);
    } else if (hash.reaction) {
      this.serializePostRelationship(hash.reaction);
    }
  }

  payloadKeyFromModelName(modelName) {
    return super.payloadKeyFromModelName(modelName).replace(/^posts\//, '');
  }

  modelNameFromPayloadKey(key) {
    if (key === 'commentAuthors') {
      return super.modelNameFromPayloadKey('person');
    }
    return super.modelNameFromPayloadKey('posts/' + key);
  }

  normalizePostRelationship(entity) {
    switch (entity.postType) {
      case PostTypes.COMMUNITY_NOTICE:
        entity.communityNoticeId = entity.postId;
        delete entity.postId;
        break;
      case PostTypes.STUDENT_NOTICE:
        entity.studentNoticeId = entity.postId;
        delete entity.postId;
        break;
      case PostTypes.STAFF_NOTICE:
        entity.staffNoticeId = entity.postId;
        delete entity.postId;
        break;
      case PostTypes.GLOBAL_NOTICE:
        entity.globalNoticeId = entity.postId;
        delete entity.postId;
        break;
      case PostTypes.TEXT:
        entity.textId = entity.postId;
        delete entity.postId;
        break;
      case PostTypes.ATTENDANCE_NOTE:
        entity.attendanceNoteId = entity.postId;
        delete entity.postId;
        break;
    }
  }

  serializePostRelationship(entity) {
    switch (entity.postType) {
      case PostTypes.COMMUNITY_NOTICE:
        entity.postId = entity.communityNoticeId;
        delete entity.communityNoticeId;
        break;
      case PostTypes.STUDENT_NOTICE:
        entity.postId = entity.studentNoticeId;
        delete entity.studentNoticeId;
        break;
      case PostTypes.STAFF_NOTICE:
        entity.postId = entity.staffNoticeId;
        delete entity.staffNoticeId;
        break;
      case PostTypes.GLOBAL_NOTICE:
        entity.postId = entity.globalNoticeId;
        delete entity.globalNoticeId;
        break;
      case PostTypes.TEXT:
        entity.postId = entity.textId;
        delete entity.textId;
        break;
      case PostTypes.ATTENDANCE_NOTE:
        entity.postId = entity.attendanceNoteId;
        delete entity.attendanceNoteId;
        break;
    }
  }
}
